import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { getLatestAppVersion } from 'api/app'
import { appKeys } from './keys'

export function useLatestAppVersion(
  options?: Pick<UseQueryOptions<string>, 'enabled'>
) {
  return useQuery({
    queryKey: appKeys.latestVersion,
    queryFn: getLatestAppVersion,
    refetchInterval: 1000 * 60 * 2, // 2 minutes
    ...options,
  })
}
